import React from 'react';
import { arrayOf, bool, func, node, oneOfType, string } from 'prop-types';

import exportWithBoundary from '../../../helpers/exportWithBoundary';
import { TabContainer } from './styles';

function Tabs({ children, onChange, selectedTab, tabStyle, underline }) {
  return (
    <TabContainer tabStyle={tabStyle} underline={underline}>
      {children.map((item, index) => {
        const itemProps = {
          tabStyle,
        };
        itemProps.onClick = () => onChange(item.key || index);
        itemProps.selected = item.key === selectedTab || index === selectedTab;
        return React.cloneElement(item, itemProps);
      })}
    </TabContainer>
  );
}

Tabs.defaultProps = {
  children: [],
  selectedTab: null,
  tabStyle: 'default',
  underline: false,
};

Tabs.propTypes = {
  children: oneOfType([arrayOf(node), node]),
  onChange: func.isRequired,
  selectedTab: string,
  tabStyle: string,
  underline: bool,
};

function TabsFallback() {
  return <TabContainer />;
}

export default exportWithBoundary(Tabs, TabsFallback);
